export default {
    methods: {
        formatCurrency(value, fractions = 2) {
            const fixedValue = Number(value).toFixed(fractions)
            const formatter = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: fractions,
                maximumFractionDigits: fractions,
            })
            return formatter.format(fixedValue)
        },
    },
}
